import { Space } from 'antd'
import React from 'react'
import Avatar from './AvatarDropdown'
// @ts-ignore
import styles from './index.module.less'
import { IUseInfoData } from './../index.d'

interface IProps {
  useInfo: IUseInfoData
}

const GlobalHeaderRight = (props: IProps): JSX.Element => {
  return (
    <Space className={styles.right}>
      <Avatar useInfo={props.useInfo} />
    </Space>
  )
}
export default GlobalHeaderRight
